import GeneralBackref from "./GeneralBackref"
import { useParams } from 'react-router-dom'

function OfflineBackref(props) {

    const { id } = useParams()

    return(
        <GeneralBackref 
            loading={false}
            success={true}
            transactionID={null}
            orderUUID={id}
            paymentAgent={"Offline"}
        />
    )
}
export default OfflineBackref